import { useEffect, useRef, useState } from 'react';
import { Accordion } from './Accordion';
import { CompulsoryFilter } from '../compulsoryfilter';
import { getTopicLabel, getTypeLabel, getLanguageLabel } from '../../tools';

export function AllFiltersButton(props) {
	const [isOpen, setIsOpen] = useState(false);
	const buttonRef = useRef(null);

	const handleClickOutside = (event) => {
		if (buttonRef.current && ! buttonRef.current.contains(event.target)) {
			toggleMenu(false);
		}
	};

	useEffect(() => {
		document.addEventListener('click', handleClickOutside);

		return () => {
			document.removeEventListener('click', handleClickOutside);
		};
	});

	const toggleMenu = (isOpen) => {
		setIsOpen( isOpen );
		// body is to hide scrollbar on mobile screens when filter popup is active.
		document.body.classList.toggle('body-toolkit-filter-popup--active', isOpen );
		// buttenRef is to better handle the grey background.
		buttonRef.current.classList.toggle('toolkit-filter-popup--active', isOpen );
	}

	const handleToggleClick = (event) => {
		event.preventDefault();
		toggleMenu( ! isOpen );
	}

	let count = 0;
	props.filteredPostList.forEach(function (section) {
		count = count + section[1].length;
	});
	const countString = count === props.allPostCount ? 'View all' : 'View ' + count;

	const className = 'toolkit-filters-popup' + ( isOpen ? ' toolkit-filters-popup--active' : '' );

	return (
		<span id="toolkit-all-filters" className="input-wrap toolkit-all-filters" ref={buttonRef}>
			<button className="btn" onClick={handleToggleClick}><i className="icon-filter"></i>All filters</button>
			<form className={className}>
				<div className="toolkit-filters-popup--header">
					<span><i className="icon-filter"></i>All filters</span>
					<span className='pull-right icon-close-button' onClick={handleToggleClick}></span>
				</div>
				<div className="toolkit-filters-popup--body">
					<Accordion
						label='Topic'
						id='topic-filter'
						options={props.topicOptions}
						selectedOptions={props.filterTopics}
						labelFunction={getTopicLabel}
						onChangeCallback={props.topicCallback}
						allCount={props.allTopicCount}
					/>
					<Accordion
						label='Document type'
						id='document-filter'
						options={props.typeOptions}
						selectedOptions={props.filterDocumentTypes}
						labelFunction={getTypeLabel}
						onChangeCallback={props.typeCallback}
						allCount={props.allTypeCount}
					/>
					<CompulsoryFilter
						checked={props.filterCompulsory}
						id={'is_compulsory_popup'}
						onChange={props.toggleCompulsory}
					/>
					<Accordion
						label='Language'
						id='language-filter'
						options={props.languageOptions}
						selectedOptions={props.filterLanguages}
						labelFunction={getLanguageLabel}
						onChangeCallback={props.languagesCallback}
						allCount={props.allLanguageCount}
					/>

				</div>

				<div className="toolkit-filters-popup--footer flex-wrap flex-md-nowrap">
					<button className="btn col-12 col-md-6 mb-4 mb-md-0 me-md-2 flex-grow-1" onClick={props.clearAllFilters}>Clear filter</button>
					<button className="btn btn-primary col-12 col-md-6 flex-grow-1" onClick={handleToggleClick}>{countString}</button>
				</div>

			</form>

		</span>
	);
}
